import { render } from "./EventComponent.vue?vue&type=template&id=d0d863f2&scoped=true"
import script from "./EventComponent.vue?vue&type=script&lang=js"
export * from "./EventComponent.vue?vue&type=script&lang=js"

import "./EventComponent.vue?vue&type=style&index=0&id=d0d863f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0d863f2"]])

export default __exports__